export const projectsData = [
    {
        id: 1,
        title: "E-Commerce Platform",
        description: "Plateforme e-commerce complète avec panier, paiement et gestion des commandes.",
        image: "https://res.cloudinary.com/daopsqlfw/image/upload/v1783860146/Capture_qe0y8n.png",
        technologies: ["React", "Node.js", "MongoDB"],
        github: "https://github.com/mohammed325"
    },
    {
        id: 2,
        title: "Task Management App",
        description: "Application de gestion des tâches avec collaboration en temps réel.",
        image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=500&h=300&fit=crop",
        technologies: ["React", "Firebase", "TypeScript"],
        github: "https://github.com/mohammed325"
    },
    {
        id: 3,
        title: "Application scolaire",
        description: "Tableau de bord analytique avec graphiques et statistiques en temps réel.",
        image: "https://images.unsplash.com/photo-1551288049-bebda4e38f71?w=500&h=300&fit=crop",
        technologies: ["React", "Spring Boot", "MongoDB"],
        github: "https://github.com/mohammed325"

    },
    {
        id: 4,
        title: "Social Media App",
        description: "Réseau social avec posts, likes, commentaires et système de suivis.",
        image: "https://res.cloudinary.com/daopsqlfw/image/upload/v1783859902/Capture_fadpuk.png",
        technologies: ["React", "Firebase", "Javascript"],
        github: "https://github.com/mohammed325"
    },
    {
        id: 5,
        title: "Weather App",
        description: "Application météo avec prévisions sur 7 jours et notifications.",
        image: "https://res.cloudinary.com/daopsqlfw/image/upload/v1783860240/OIP_aea4js.webp",
        technologies: ["React", "API REST", "JavaScript"],
        github: "https://github.com/mohammed325"
    },
    {
        id: 6,
        title: "AI Chatbot",
        description: "Chatbot intelligent avec traitement du langage naturel.",
        image: "https://images.unsplash.com/photo-1531746790731-6c087fecd65a?w=500&h=300&fit=crop",
        technologies: ["React", "Python", "Machine Learning"],
        github: "https://github.com/mohammed325"
    }
];